import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { addMember } from '../actions/members';
import { MEMBERS_VISIBILITY_UPDATED } from '../actionTypes';
import { getCurrentThreadId } from '../selectors/threads';
import {
    areCurrentMembersLoading,
    currentThreadMemberProfileIds,
    currentThreadMembers,
    isMembersPanelVisible,
} from '../selectors';
import MembersPanelComponent from '../components/MembersPanelComponent';

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        members: currentThreadMembers,
        memberProfileIds: currentThreadMemberProfileIds,
        threadId: getCurrentThreadId,
        isLoading: areCurrentMembersLoading,
        membersVisible: isMembersPanelVisible,
    }),

    (dispatch) => ({
        // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { container }: $TSFixMe) => any' is not assignable to paramet...
        onMemberSelect: (threadId: $TSFixMe, member: $TSFixMe) => dispatch(addMember(threadId, member)),
        onClosePanel: () => dispatch(createAction(MEMBERS_VISIBILITY_UPDATED, false)),
    })
    // @ts-expect-error $TSFixMeError: Argument of type 'typeof (Anonymous class)' is not assignable to parameter of type 'ComponentType<Matching<{ members: ob...
)(MembersPanelComponent);
